































import { Component, Vue, Prop } from 'vue-property-decorator'
import store from '@/store'
import { getOpenEnd } from '@/components/Survey/Utilities/SurveyUtilities'
import { Response, Question } from '@/store/modules/survey-store-module'
import { Checkbox } from '@alpha/ink'
import AnswerToggle from './AnswerToggle.vue'
import { ResponseRemovalMessaging } from '@/components/Survey/Utilities/MessagingUtilities'
import { RespondentSurveyState } from '@alpha/shared/src/entities/RespondentSurveyEvent'

@Component({
  components: {
    AnswerToggle,
    Checkbox
  }
})
export default class QuestionResponse extends Vue {
  @Prop({ required: true }) response!: Required<Response>
  @Prop({ required: true }) question!: Question
  @Prop({ required: true }) readonly respondentRemovalMap!: Record<string, boolean>
  @Prop({ required: true }) readonly responseRemovalMap!: Record<string, boolean>
  @Prop({ required: true }) isAlphaAdmin!: boolean

  get respondentId () {
    return this.response.respondentSurveyId
  }

  get respondentForResponse () {
    return store.getters.survey.respondentById(this.respondentId)
  }

  get simpleId () {
    return this.respondentForResponse.simpleId
  }

  get disabled () {
    return !this.respondentSelected || this.toggleDisabled
  }

  get toggleDisabled () {
    return this.rejected && !this.isAlphaAdmin
  }

  get checkboxTooltip () {
    if (this.toggleDisabled) return ResponseRemovalMessaging.ResponseRemoved
    if (!this.respondentSelected) return ResponseRemovalMessaging.RespondentRemoved
    return ResponseRemovalMessaging.Accepted
  }

  get rejected () {
    return this.response.status === RespondentSurveyState.REJECTED_BY_DS
  }

  get responseShown () {
    return this.responseRemovalMap[this.response.id] && this.respondentSelected
  }

  get respondentSelected () {
    return this.respondentRemovalMap[this.respondentId]
  }

  get responseText () {
    return getOpenEnd(this.response, this.question)
  }

  toggleResponseRemoval ($event: MouseEvent | boolean) {
    if (this.disabled) return
    let shiftClick = false
    if (typeof $event !== 'boolean') {
      shiftClick = $event.shiftKey
      const selection = document.getSelection()
      if (selection) selection.removeAllRanges()
    }
    this.$emit('toggleResponseRemoval', { response: this.response, shiftClick })
  }
}
